import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-1087',
  templateUrl: './footer-1087.component.html',
  styleUrl: './footer-1087.component.scss'
})
export class Footer1087Component {

}
